module.exports = __webpack_public_path__ + "static/media/clubsColored.06b49b24.svg";